module.exports = __webpack_public_path__ + "img/mgHot.e6416bd1.webp";